// src/pages/AddCollection.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../components/Api";

export default function AddCollection() {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        license_card_id: "",
        collection_name: "",
    });
    const [licenses, setLicenses] = useState([]);
    const [existingNames, setExistingNames] = useState([]);

    // Récupération des licences et collections existantes
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [resLicenses, resCollections] = await Promise.all([
                    api.get("/license-cards"),
                    api.get("/collections"),
                ]);
                setLicenses(resLicenses.data);
                setExistingNames(resCollections.data.map(c => ({
                    name: c.collection_name,
                    license_card_id: c.license_card_id
                })));
            } catch (err) {
                console.error(err);
                alert("Erreur lors de la récupération des données.");
            }
        };
        fetchData();
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { license_card_id, collection_name } = form;

        if (!license_card_id) return alert("Veuillez sélectionner une licence.");
        if (!collection_name.trim()) return alert("Le nom de la collection est obligatoire.");

        // Vérifier doublon pour la même licence
        const duplicate = existingNames.some(
            c => c.name.toLowerCase() === collection_name.trim().toLowerCase() &&
                c.license_card_id === parseInt(license_card_id)
        );
        if (duplicate) return alert("Cette collection existe déjà pour cette licence.");

        try {
            await api.post("/collections", { license_card_id, collection_name: collection_name.trim() });
            alert("Collection ajoutée avec succès !");
            navigate("/collection-list");
        } catch (err) {
            console.error(err);
            alert("Erreur lors de l'ajout de la collection.");
        }
    };

    const token = localStorage.getItem("token");
    if (!token || localStorage.getItem("role") > 2) navigate("/");

    return (
        <div className="container mx-auto p-6 max-w-md">
            <h1 className="text-2xl font-bold mb-4">Ajouter une Collection</h1>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="license_card_id" className="block font-medium mb-1">Licence :</label>
                    <select
                        id="license_card_id"
                        name="license_card_id"
                        value={form.license_card_id}
                        onChange={handleChange}
                        className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 bg-white"
                        required
                    >
                        <option value="">-- Sélectionnez une licence --</option>
                        {licenses.map(l => (
                            <option key={l.id} value={l.id}>{l.license_card}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label htmlFor="collection_name" className="block font-medium mb-1">Nom de la collection :</label>
                    <input
                        type="text"
                        id="collection_name"
                        name="collection_name"
                        value={form.collection_name}
                        onChange={handleChange}
                        className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 bg-white"
                        required
                    />
                </div>

                <button
                    type="submit"
                    className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded"
                >
                    Ajouter
                </button>
            </form>
        </div>
    );
}
